import React, { Component } from 'react';
import Spin from '../../../../commonModules/interface/Spin';
import { isEmpty } from 'lodash'
import { ListLayout } from '../../../Menu/Stock/containers/Layout';
import { TableHead, TableRow, TableCell, Box, Typography, TableBody, IconButton, CircularProgress } from '@material-ui/core';
import { Autorenew } from '@material-ui/icons';

class CommercialStockInfo extends Component {
    state = {  }

    render() {
        const { stocks, loading } = this.props;
        return (
            <Box>
                {(!stocks || loading ) ?
                    <CircularProgress color="secondary" size={60} style={{textAlign:"center"}} />
                :
                    <Box style={{ textAlign: "right"}}>
                        <IconButton color="secondary" onClick={this.props.refreshData}>
                            <Autorenew />
                        </IconButton>
                        {isEmpty(stocks) && stocks &&
                            <p>Pas de stock</p>
                        }
                        {!isEmpty(stocks) && 
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell component="th">Nom</TableCell>
                                        <TableCell component="th">Marque</TableCell>
                                        <TableCell component="th">Référence</TableCell>
                                        <TableCell component="th">Quantité</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {stocks.map( stock => 
                                    <TableRow key={stock.product && stock.product.id}>
                                        <TableCell>{stock.product && stock.product.name}</TableCell>
                                        <TableCell>{stock.product && stock.product.marque}</TableCell>
                                        <TableCell>{stock.product && stock.product.ref}</TableCell>
                                        <TableCell>{stock.quantity}</TableCell>
                                    </TableRow>
                                    )}
                                </TableBody>
                            </ListLayout>
                        }
                    </Box>
                }
            </Box>
        );
    }
}

export default CommercialStockInfo;